<!--
  - Copyright (c) 2020.
  - Project: Source
  - LastModified: 2/14/20, 3:23 PM
  - Author: diengv < Giáp Văn Điện >
  - Email: diengv@ominext.com
  - File name: index.vue
  - File path: D:/Projects/PMS/Source/Client/vuejs/src/resources/views/quiz/index.vue
  -->

<template>
    <div>Quiz</div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>
